import View            from '@widesk-ui/components/View';
import useDesignTokens from '@/hooks/useDesignTokens';
import React           from 'react';

export default function SectionTitle({ children }: { children: React.ReactNode; }) {
	const tokens = useDesignTokens();

	if (!children) return null;

	return (
		<View
			color={tokens.text.muted}
			bold
			uppercase
			size={11.5}
			style={{ letterSpacing: '.08em' }}
		>
			{children}
		</View>
	);
}